import {SFuncModal, SLowcodeList} from "shj-components";
import zhCN from "antd/lib/locale/zh_CN";
import {useEffect, useState} from "react";
import {Button, ConfigProvider, Input, InputNumber, message} from "antd";
import {getUser, getUserInfo} from "@/common/utils.ts";
import {dcpAppUserList} from "@/services/kuAccount.ts";
import {apiData2Table} from "@/utils/data.ts";

enum vipTypeEnum {
  '可改 VIP' = 1,
  '铂金 VIP' = 3,
  '钻石 VIP' = 4,
  '不可改 VIP' = 5,
  '黄金 VIP' = 6,
  '白银 VIP' = 7,
}

export function kjlAccountFn({ fn, ...rest }: any) {
  const onClose = () => {
    dialog.destroy();
  };

  const dialog = SFuncModal({
    title: `酷家乐账号`,
    width: 800,
    vanish: true,
    content: (
        <>
          <ConfigProvider locale={zhCN}>
            <KjlAccountModelDom onClose={onClose} fn={fn} {...rest} />
          </ConfigProvider>
        </>
    ),
  });

  return dialog;
}

const KjlAccountModelDom = (props: any) => {
  const { onClose, fn, source, ...rest } = props;
  const [data, setData] = useState([]);
  const [projectId, setProjectId] = useState('');
  const [loadingObj, setLoadingObj] = useState({});
  const [loadingId, setLoadingId] = useState('');
  const [total, setTotal] = useState<number>(0);
  const columns = [
    {
      title: '酷家乐账号',
      dataIndex: 'kjlAccount',
      key: 'kjlAccount',
      width: 200,
      ellipsis: true,
    },
    // {
    //   title: '酷家乐账号名称',
    //   dataIndex: 'kjlName',
    //   key: 'kjlName',
    // },
    {
      title: '权益',
      dataIndex: 'vipType',
      key: 'vipType',
      render(val: any) {
        return vipTypeEnum[val];
      },
    },
    {
      title: '状态',
      dataIndex: 'idle',
      key: 'idle',
      render(val: any) {
        if (val === 0) {
          return '空闲';
        } else if (val === 1) {
          return '使用中';
        } else {
          return '';
        }
      },
    },
    {
      title: '使用人',
      dataIndex: 'user',
      key: 'user',
      render: (_, record) => {
        if (record?.user && record?.idle !== 0) {
          return record?.user?.userName;
        } else {
          return '';
        }
      },
    },
    {
      title: '操作',
      key: 'action',
      render: (_, record) => {
        if (record?.idle === 0 && source == 'new') {
          return (
              <Button
                  type="primary"
                  size={'small'}
                  onClick={() => {
                    fn && fn(record?.appuid).then(onClose).catch();
                    // onClose();
                  }}
              >
                去使用
              </Button>
          );
        } else if (source == 'copy') {
          return (
              <Button
                  loading={loadingObj[record.id]}
                  disabled={!!(loadingId && !loadingObj[record.id])}
                  type="primary"
                  size={'small'}
                  onClick={() => {
                    if (loadingId) return;
                    if (rest.fromPerson && !projectId) {
                      message.error('请输入方案id');
                      return;
                    }
                    setLoadingObj({[record.id]: true})
                    setLoadingId(record.id)
                    fn && fn(record?.appuid, projectId).then(onClose).catch().finally(() => {
                      setLoadingObj({[record.id]: false})
                      setLoadingId('')
                    })
                  }}
              >
                复制到本账号
              </Button>
          );
        }
      },
    },
  ];

  const fetchList = async ({current, pageSize, query}) => {
    return new Promise((resolve, reject) => {
      const company = getUser()?.companyId;
      dcpAppUserList(current, pageSize, {...query, companyCode: company}).then(res => {
        console.log(res, 111)
        setData(res.list || [])
        setTotal(res.count || 0)
        resolve(apiData2Table(res))
      }).catch(reject)
    })

  };

  const extensions = {
    // dataSource: data,
    // total,
    rowKey: 'id',
    request: {fetchList}
  }

  return (
      <SFuncModal.Content footer={null}>
        {rest.fromPerson ? (
            <>
            方案ID: <InputNumber
                placeholder={'请输入方案ID'}
                style={{width: 200}}
                name="name"
                label="方案ID"
                rules={[{ max: 100, message: '名称过长！' }]}
                value={projectId}
                onBlur={(e) => {
                  setProjectId(e.target.value);
                }}
            />
            </>
        ) : null}
        <SLowcodeList
            searchMode={'group'}
            config={{columns, fieldControl: false, rowSelection: false, scroll: {y: 350}}}
            {...extensions}
        />
      </SFuncModal.Content>
  );
};
